<mat-checkbox
  [(ngModel)]="isChecked"
  [indeterminate]="isIndeterminate"
  (change)="toggleSelect()"
></mat-checkbox>
